import { CardVariantsEnum } from "./types";

export const NULL_COMPONENTS_BY_VARIANT: Record<
    CardVariantsEnum,
    Record<string, null>
> = {
    standard: { description: null },
    headline: { imageURL: null, description: null, author: null },
    listing: {},
    listing_horizontal: { author: null },
    condensed: { imageURL: null, flag: null, description: null },
    condensed_square_thumb: { description: null },
    horizontal: { flag: null, description: null },
    discovery: { description: null, updateTime: null },
    minimal: {
        description: null,
        flag: null,
        departments: null,
        updateTime: null,
    },
    text_with_link: {
        flag: null,
        departments: null,
        updateTime: null,
        author: null,
        imageURL: null,
    },
};

// specific - applies to path only, e.g. the key "radio" applies to "/radio" only
export const CONTENTITEM_PROP_EXCLUSION_LIST_BY_PATH = new Map<
    string,
    string[]
>([
    ["television", ["author", "updateTime"]],
    ["radio", ["author"]],
    ["life", ["author"]],
    ["home", ["author", "updateTime"]],
    ["documentaries", ["author", "updateTime"]],
    ["archives", ["author"]],
]);

// catchall - applies to basepath and any nested path, e.g. the key "player"
// applies to "/player", "/player/news", "/player/news/live", and so on.
export const CONTENTITEM_PROP_EXCLUSION_LIST_BY_BASEPATH = new Map<
    string,
    string[]
>([["player", ["author", "flag"]]]);
